import React from "react";
import ResponsiveAppBar from "./responsive-app-bar";
import {Container, Typography} from "@mui/material";
import Spacer from "./Spacer";
import Footer from "./home/Footer";
import {useLocation} from "react-router-dom";
import {reinstateLinkFor} from "../assets/reinstate-link";

function NoFurtherRenewals({annualReportsOnly = false}: {annualReportsOnly?: boolean}){
    const {search} = useLocation();
    return (<>
        <ResponsiveAppBar showLogin={false}/>
        <Container maxWidth={"md"}>
            <Spacer height={50}/>
            <Typography align={"center"} variant={"h4"} component="h1">
                {annualReportsOnly ? "Annual report filing is closed for this year." : "Our filing season is over for this year."}
            </Typography>
            <Spacer height={50}/>
            {annualReportsOnly ? (
                <Typography align={"center"}>
                    We're currently not accepting annual report filings. If your company was administratively dissolved,
                    you can still <a href={reinstateLinkFor(search)}>reinstate it</a>. For assistance with an existing order, please contact support.
                </Typography>
            ) : (
                <Typography align={"center"}>
                    We're currently not accepting new filing requests. For assistance with an existing order, please contact support.
                </Typography>
            )}
            <Spacer height={50}/>
            <Typography align={"center"}>
                Feel free to contact our support team at <a href={"mailto:support@fcfiling.com"}>support@fcfiling.com</a> with any further questions.
            </Typography>
        </Container>
        <Spacer height={250}/>
        <Footer/>

    </>);
}

export default NoFurtherRenewals
